import { useLocale } from 'react-admin';

type LocaleKey = 'en' | 'ru';
type LocaleMap<TLocale> = Record<LocaleKey, TLocale>;

export const useNormalizedLocale = <TLocale>(localeMap: LocaleMap<TLocale>) => {
  const locale = useLocale() as LocaleKey;
  return localeMap[locale];
};
